import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Report } from '../../../../graphql/reports.datatypes';
import { gqlReport } from '../getReportByKey.api';

export interface UpdateReportVars {
    data: {
        id: number,
        name?: string
        query?: string
        url_key?: string
        shared?: boolean
    };
}

interface UpdateReportData {
    __typename?: string,
    updateReport: Report
}

export const UPDATE_REPORT_MUTATION = gql`
    mutation updateReport($data: UpdateReportInput!) {
        updateReport(data: $data) {
            ${gqlReport}
        }
    }
`;

export const updateReport = () => useMutation<UpdateReportData, UpdateReportVars>(
  UPDATE_REPORT_MUTATION,
    {}
);

export default updateReport;